import React, {useCallback} from 'react';

import {ACCOUNT_STRIP_LABELS} from 'src/components/criteria-strip/constants';
import {useLicenseTypes} from 'src/hooks/dictionaries';

import {CheckBox} from '@pb/kit-component-checkbox';
import {ComboBox, ComboboxItem, DefaultItem} from '@pb/kit-component-combo-box';
import {Group} from '@pb/kit-component-group';
import Label from '@pb/kit-component-label';


import type {SearchCriteria} from 'src/components/criteria-strip/services/criteria-strip-slice';

type Props = {
    width: number,
    criteria: SearchCriteria,
    onChange: (licenseType: string, includeInactiveLicense: boolean) => void,
};

export const LicenseType = ({criteria, width, onChange}: Props) => {
    const {licenseTypes} = useLicenseTypes();

    const changeLicenseType = useCallback((licenseType: string) => {
        const includeInactiveCrm = !!criteria.licenseType?.some(({value}) => value === 'includeInactiveLicenses');
        onChange(licenseType, includeInactiveCrm);
    }, [onChange, criteria]);

    const setInactiveLicense = useCallback((e: {
        event: React.SyntheticEvent<HTMLInputElement, Event>,
        name: string,
    }) => {
        const licenseType = criteria
            .licenseType?.find(({value}) => value !== 'includeInactiveLicenses')?.value;
        const includeInactiveCrm = e.event.currentTarget.checked;

        onChange(licenseType || '', includeInactiveCrm);
    }, [onChange, criteria]);

    return (
        <div style={{width}}>
            <Group justify="space-between">
                <Label>{ACCOUNT_STRIP_LABELS.licenseType}</Label>
                <Group gap="s">
                    Include inactive licenses
                    <CheckBox
                        disabled={!criteria.licenseType}
                        checked={criteria.licenseType?.some(({value}) => value === 'includeInactiveLicenses')}
                        onCheckBoxChange={setInactiveLicense}
                    />
                </Group>
            </Group>
            <ComboBox
                placeholder="Select license type"
                value={criteria
                    .licenseType?.find(({value}) => value !== 'includeInactiveLicenses')?.value}
                onChange={changeLicenseType}>
                {
                    [
                        <DefaultItem key="None" value=""/>,
                        ...licenseTypes.map(({code, description}) => (
                            <ComboboxItem key={code} caption={description} value={code}/>
                        )),
                    ]
                }
            </ComboBox>
        </div>
    );
};
